export default {
    methods: {
        formatPlan(item) {
            let result = "";
            if (item.type !== null) {
                result += `${item.type} | `;
            }

            result += item.trial
                ? this.$t("trial")
                : this.$tc("year", item.plan);

            return result;
        },
        sortPlan(a, b) {
            const aType = a.type ?? "";
            const bType = b.type ?? "";
            const aPlan = a.plan ?? -1;
            const bPlan = b.plan ?? -1;

            if (aType < bType) {
                return 1;
            } else if (aType > bType) {
                return -1;
            } else {
                if (aPlan < bPlan) {
                    return 1;
                } else if (aPlan > bPlan) {
                    return -1;
                } else {
                    return 0;
                }
            }
        }
    }
};
